

import {React, useRef, useEffect, useState} from "react";
import {motion, useTransform, useScroll , useSpring} from "framer-motion";
import '../../assets/css/styles.css';

const Roadmap = () => {
    const { scrollYProgress } = useScroll()
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001,
    })

    return(
        <>
            <motion.div
                id="scroll-indicator"
                style={{
                    scaleX,
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 10,
                    originX: 0,
                    backgroundColor: "#ffffff",
                    zIndex: 20,
                }}
            />
            <HorizontalScrollCarousel />
        </>
            

    )
}

const HorizontalScrollCarousel = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  let targetRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: targetRef,
  });

  const x = useTransform(scrollYProgress, [0, 1], ["43%", "-41%"]);

  // Update isMobile state on window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  
    return (
  
      <section ref={targetRef} className="lg:relative h-auto lg:h-[300vh] bg-gradient-to-r from-teal-900 via-green-500 to-teal-900">
  
        <div className={`text-white  lg:top-0 flex lg:h-screen w-full items-center ${isMobile ? "":"sticky overflow-hidden"} `}>
  
        <motion.div
          style={isMobile ? {} : { x }} // Disable horizontal scroll on mobile
          className={`flex ${isMobile ? "flex-col space-y-10" : "space-x-60"}`} // Switch to vertical layout on mobile
        >
            <div class="flex w-screen h-screen items-center justify-center content-center" >
                <h1 class="mt text-5xl bold ">
                    #1 Begin operations at Macanista
                </h1>
            </div>
            <div class="flex w-screen h-screen items-center justify-center content-center" >
                <h1 class="mt text-5xl bold ">
                    #2 Acquire INSERR
                </h1>
            </div>
            <div class="flex w-screen h-screen items-center justify-center content-center" >
                <h1 class="mt text-5xl bold ">
                    #3 Acquire funds for productions
                </h1>
            </div>
            <div class="flex w-screen h-screen items-center justify-center content-center" >
                <h1 class="mt text-5xl bold ">
                    #4 Release INSERR for consumers
                </h1>
            </div>
            <div class="flex w-screen h-screen items-center justify-center content-center" >
                <h1 class="mt text-5xl bold ">
                    #5 Humanoid Robotics RnD
                </h1>
            </div>
  
          </motion.div>
  
        </div>
  
      </section>
  
    );
  
  };

  export default Roadmap;

/*
"use client"

import {
    motion,
    MotionValue,
    useScroll,
    useSpring,
    useTransform,
} from "framer-motion"
import { useRef } from "react"
import React from "react"
import {Navbar} from "../../components/common"
import { Nav } from "../../components/common/navbar/NavbarElements"

function useParallax(value: MotionValue<number>, distance: number) {
    return useTransform(value, [0, 1], [-distance, distance])
}

function Image({ id }: { id: number }) {
    const ref = useRef(null)
    const { scrollYProgress } = useScroll({ target: ref })
    const y = useParallax(scrollYProgress, 300)

    return (
        <div>
        <Navbar/>
        <section className="img-container">
            
            <div ref={ref}>
                <img
                    src={`/photos/cityscape/${id}.jpg`}
                    alt="A London skyscraper"
                />
            </div>
            <motion.h2
                // Hide until scroll progress is measured
                initial={{ visibility: "hidden" }}
                animate={{ visibility: "visible" }}
                style={{ y }}
            >{`#00${id}`}</motion.h2>
        </section>
        </div>
    )
}

export default function Parallax() {
    const { scrollYProgress } = useScroll()
    const scaleX = useSpring(scrollYProgress, {
        stiffness: 100,
        damping: 30,
        restDelta: 0.001,
    })

    return (
        <div id="example">
            {[1, 2, 3, 4, 5].map((image) => (
                <Image key={image} id={image} />
            ))}
            <motion.div className="progress" style={{ scaleX }} />
            <StyleSheet />
        </div>
    )
}


function StyleSheet() {
    return (
        <style>{`
         html {
            scroll-snap-type: y mandatory;
        }

        .img-container {
            height: 100vh;
            scroll-snap-align: start;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
        }

        .img-container > div {
            width: 300px;
            height: 400px;
            margin: 20px;
            background: #f5f5f5;
            overflow: hidden;
        }

        .img-container img {
            width: 300px;
            height: 400px;
        }

        @media (max-width: 500px) {
            .img-container > div {
                width: 150px;
                height: 200px;
            }

            .img-container img {
                width: 150px;
                height: 200px;
            }
        }

        .img-container h2 {
            color: #4ff0b7;
            margin: 0;
            font-family: JetBrains Mono, monospace;
            font-size: 50px;
            font-weight: 700;
            letter-spacing: -3px;
            line-height: 1.2;
            position: absolute;
            display: inline-block;
            top: calc(50% - 25px);
            left: calc(50% + 120px);
        }

        .progress {
            position: fixed;
            left: 0;
            right: 0;
            height: 5px;
            background: #4ff0b7;
            bottom: 50px;
            transform: scaleX(0);
        }
    `}</style>
    )
}
*/